export default [
  {
    key: 'id',
    type: 'id',
    visibility: ['view'],
  },
  {
    key: 'invoice_number',
    label: 'No. Invoice',
  },
  {
    key: 'buyer_name',
    label: 'Pembeli',
    type: 'profile',
    image: 'buyer_photo_url',
  },
  {
    key: 'registry_name',
    label: 'Pemilik Registry',
    type: 'profile',
    image: 'registry_photo_url',
    visibility: ['view'],
  },
  {
    key: 'merchant_name',
    label: 'Brand',
    type: 'profile',
    image: 'merchant_image_url',
  },
  {
    key: 'delivery.tracking_number',
    label: 'No. Resi',
    visibility: ['view'],
  },
  {
    key: 'delivery.name',
    label: 'Kurir',
    visibility: ['view'],
  },
  {
    key: 'total_product',
    label: 'Total Produk',
    prefix: 'Rp ',
    visibility: ['view'],
  },
  {
    key: 'delivery.fee',
    label: 'Biaya Pengiriman',
    prefix: 'Rp ',
    visibility: ['view'],
  },
  {
    key: 'total_order',
    label: 'Total Belanja',
    prefix: 'Rp ',
  },
  {
    key: 'status',
    label: 'Status',
    type: 'badge',
    map: {
      created: 'secondary',
      confirmed: 'info',
      accepted: 'secondary',
      pickedup: 'primary',
      delivered: 'success',
      cancelled: 'danger',
      rejected: 'danger',
      refund_pending: 'warning',
      refunded: 'dark',
    },
  },
]
